import { PricingStatusConfigurationType } from 'constants/loanApplication';

export const DELAY_CONNECTION_CHECK = 1000;

export const LOCK_INFO_PATH_PATTERN = /\/loan-and-lock\/lock-info/;

export const baseConfigurations = [PricingStatusConfigurationType.PROGRAM_CHANGE_CONFIGURATION];

export const lockInfoConfiguration = [
  ...baseConfigurations,
  PricingStatusConfigurationType.PRICE_CONCESSION_CONFIGURATION,
];
